import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Notification, useToaster } from "rsuite";
import Table from "rc-table";

import { Translation } from "react-i18next";
import { PartnerService } from "_services";
import i18n from "i18n";

import { HiUserGroup, HiOutlineUserGroup } from "react-icons/hi2";
import RowTable from "components/Tables/RowTable";
import ChildUserTable from "components/Tables/ChildUserTable";

const columns = [
  {
    title: "UserID",
    dataIndex: "UserID",
    className: "",
    key: "UserID",
    width: 80,
  },
  {
    id: "UserName",
    title: "UserName",
    dataIndex: "UserName",
    className: "b",
    key: "UserName",
    width: 200,
  },

  {
    title: "Operations",
    dataIndex: "",
    className: "text-right",
    key: "d",
    render() {
      return <a href="#">Operations</a>;
    },
  },
];

const datax = [
  { a: "123", key: "1" },
  { a: "cdd", b: "edd", key: "2" },
  { a: "1333", c: "eee", d: 2, key: "3" },
];

export const ReadGamers = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState(null);

  const toaster = useToaster();
  const message = (msg, type) => {
    return <Notification type={type} header={msg} closable></Notification>;
  };

  useEffect(() => {
    getListData();
  }, []);

  const getListData = async () => {
    setLoading(true);
    await PartnerService.READ_GAMERS()
      .then((res) => {
        setLoading(false);
        setData(res);
      })
      .catch((err) => {
        setLoading(false);

        debugger;
        if (err) {
          toaster.push(message(i18n.t("MESSAGE_CREATE_GAMER_FAILD"), "error"), {
            duration: 2000,
          });
        } else {
          toaster.push(message(i18n.t("MESSAGE_CREATE_GAMER_FAILD"), "error"), {
            duration: 2000,
          });
        }
      });
  };

  const onExpand = (expanded, record) => {
    // eslint-disable-next-line no-console
    //console.log("onExpand", expanded, record);
  };

  function CustomExpandIcon(props) {
    return (
      <div
        className={`btn btn-primary text-white ${
          props.expanded ? "" : "btn-outline"
        } btn-sm btn-square`}
        onClick={(e) => {
          props.onExpand(props.record, e);
        }}
        // eslint-disable-next-line react/no-danger
      >
        {props.expanded ? <HiOutlineUserGroup /> : <HiUserGroup />}
      </div>
    );
  }

  return (
    <Translation>
      {(t) => (
        <div>
          <div className="border-b py-3 border-primary-500 mb-5 shadow-xl">
            <label className="text-lg text-white">
              {t("MENU_ITEM_GAMERS")}
            </label>
          </div>
          <div>
            <Table
              rowKey={(record, key) => record.RecordTime + key}
              columns={columns}
              rowClassName={(record, i) =>
                `border-b border-secondary-400/20 row-${i}`
              }
              expandable={{
                expandRowByClick: true,
                expandedRowRender: (record) => (
                  <div className="p-4 bg-secondary-800 rounded-sm m-0">
                    <ChildUserTable childs={record.Childs} rowData={record} />
                  </div>
                ),
                onExpand,
                expandIcon: CustomExpandIcon,
              }}
              data={
                data
                  ? [
                      ...data.map((item) => ({
                        ...item,
                        key: item.UserID,
                      })),
                    ]
                  : []
              }
              className="table table-sm w-full bg-secondary-500"
            />
          </div>
        </div>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user, loggedIn } = authentication;

  return {
    user,
    loggedIn,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ReadGamers);
